module.exports = __webpack_public_path__ + "static/media/DecoderRing.8063c439.gif";